
<div v-if="isActivated">
  <b-col class="p-0" :class="{ pleineLargeur: pleineLargeur }">
    <b-row class="d-lg-none position-relative menu-haut m-0">
      <b-col class="position-absolute fleche-retour p-0">
        <Hyperlien
          :content="{
            texte: '',
            type: 'lienPrimaire',
            lien: { field: 'precedent' },
            urlRetour: '/casino/accueil',
          }"
          class="h-100"
        />
      </b-col>
    </b-row>
    <b-row
      v-if="isJeuLance || isJeuLanceModeDemo"
      class="m-0 position-relative d-flex justify-content-center jeu-lance"
    >
      <div v-if="produit.videoSnapshotBG">
        <b-img :src="produit.videoSnapshotBG" :alt="produit.name" class="image-ced h-100 w-100" />
      </div>
      <MediaImageFocalPoint
        v-else
        :content="{
          formatRatio: $isMobile() ? '1x1' : '16x9',
          image: produit.image,
        }"
        class="w-100"
      />
      <!-- Ajout bouton fermerJeu avec Modale de confirmation -->
      <div id="btn-fermer-jeu" class="btn-close d-flex justify-content-end">
        <b-button class="btn" @click="afficherMessageFermetureJeu()">
          <svg-icon class="svg-icone" icon-name="ic-fermer"></svg-icon>
        </b-button>
        <!-- Modale de confirmation du choix de fermeture du jeu -->
        <ModaleConfirmerChoix
          v-show="isModaleFermetureJeuVisible"
          :content="contentModaleConfirmQuitterJeu"
          @confirm="fermerJeu()"
          @cancel="fermerModaleFermetureJeu()"
        />
      </div>
      <iframe
        v-if="!isJelMobile"
        id="jeu-iframe"
        :title="produit.name"
        :src="getUrl()"
        class="h-100 position-absolute border-0"
        @load="cacherMenu()"
      ></iframe>
    </b-row>
    <b-row v-else class="m-0 background-jeu">
      <div class="w-100">
        <b-img
          v-if="produit.videoSnapshotBG"
          :src="produit.videoSnapshotBG"
          :alt="produit.name"
          class="image-ced w-100"
        />
        <div
          class="w-100 banniere-container"
          :class="{
            'banniere-active':
              isProduitDesactive ||
              messageDesactivation ||
              isLotProgressif ||
              isProduitMASEnDirect,
          }"
        >
          <MediaImageX3 :show="true" :content="contentMediaImageX3" :preloadForAnimation="true" />
        </div>

        <div class="w-100">
          <div :class="{ 'disabled-overlay': isProduitDesactive }"></div>
          <div
            class="banniere-progressif"
            :class="[
              isProduitDesactive || messageDesactivation
                ? 'desactive'
                : { actif: isLotProgressif },
              { mas: isProduitMASEnDirect },
            ]"
          >
            <CarteInfoSecondaireDesactivation
              v-if="isProduitDesactive || messageDesactivation"
              :content="{ texteDesactivation: messageDesactivation }"
            />
            <BanniereInfoLotProgressif
              v-else-if="isLotProgressif"
              :content="{ produit: produit, isListeHorizontale: false }"
              class="px-2"
            />
            <BanniereInfoMASEnDirect
              v-else-if="isProduitMASEnDirect"
              :content="{
                produit: produit,
              }"
            />
          </div>
        </div>
      </div>
    </b-row>
    <div class="bg-white d-flex justify-content-center menu-jeu">
      <b-row class="barre-options border-top border-bottom w-100 px-2 m-0">
        <b-col cols="4" class="d-none d-lg-flex justify-content-start align-items-center mh-100">
          <Hyperlien :content="hyperlienRetour" class="graphik_semibold hyperlien-retour" />
        </b-col>
        <b-col
          class="text-md-center d-flex justify-content-start justify-content-lg-center align-items-center themeAccent px-2"
          :cols="jel_isEcranDesktop($mq) ? 4 : isDisponibleAppareil ? 7 : 12"
        >
          <template v-if="isDisponibleAppareil">
            <span @click.capture="gaPreventClickJouer('jouer')">
              <b-button
                v-show="!isJeuLance || isJeuLanceModeDemo"
                class="w-md-auto hauteur px-4 py-1 bouton-jouer"
                :class="[isProduitDesactive ? 'btn-produit-desactive' : 'btn-primaire']"
                :disabled="isProduitDesactive"
                @click="
                  isJeuLanceModeDemo ? confirmerChangerModeJeu() : lancerJeu((mode = 'jouer'))
                "
                v-html="getTexteBoutonJouer"
              />
            </span>
            <span @click.capture="gaPreventClickJouer('demo')">
              <b-link
                v-show="isDemoDisponible && !isJeuLanceModeDemo"
                class="graphik_medium caption-2 mode-gratuit lienAsset pr-0 ml-2"
                :class="{ desactive: isProduitDesactive }"
                :disabled="isProduitDesactive"
                @click="isJeuLance ? confirmerChangerModeJeu() : lancerJeu((mode = 'demo'))"
              >
                {{
                  $t('messageComponent.modeDemo') +
                  (isJeuLance ? $t('messageComponent.modeDemoJeuLance') : '')
                }}
              </b-link>
            </span>
          </template>
          <div v-else class="modale-information-jeu">{{ indisponibleAppareil }}</div>
          <!-- Modale information Jeu -->
          <ModaleInformation
            v-show="isModaleInfoJeuVisible"
            :content="contentModaleInformationJeu"
            @close="fermerModaleInformationJeu()"
          />
          <!-- Modale information erreur lancement Jeu -->
          <ModaleInformation
            v-show="isModaleErreurVisible"
            :content="contentModaleErreurLancementJeu"
            @close="fermerModaleErreur()"
          />
          <!-- Modale confirmation choix changement de mode de Jeu -->
          <ModaleConfirmerChoix
            v-show="isModaleConfirmChangeModeVisible"
            :content="contentModaleConfirmChangeModeJeu"
            @confirm="lancerJeu((mode = isJeuLanceModeDemo ? 'jouer' : 'demo'), true)"
            @cancel="fermerModaleConfirmerMode()"
          />
          <!-- Modale information Jeu MAS en direct -->
          <ModaleInformationJeuMASEnDirect
            v-show="isModaleInfoJeuMASEnDirectVisible"
            :content="contentModaleInformationJeuMASEnDirect"
            @confirmer="fermerModaleMASEnDirect()"
            @annuler="lancerJeuMASenDirect()"
          />
        </b-col>
        <b-col
          v-if="isDisponibleAppareil"
          class="d-flex align-items-center justify-content-end px-2"
          :cols="jel_isEcranDesktop($mq) ? 4 : 5"
        >
          <span @click.capture="gaPreventClick('favori')">
            <button
              :aria-label="isConsentant ? '' : $t('messageComponent.texteConsentement')"
              class="bouton-icone tooltip-favoris"
              @click="toggleFavori()"
            >
              <svg-icon
                class="taille-icone"
                :class="{ 'loi-25': !isConsentant }"
                :icon-name="isFavori ? 'icone-favori-noir' : 'icone-favori'"
              />
              <span v-if="!isConsentant" class="erreur">
                <svg-icon icon-name="icone-avertissement" />
              </span>
              <span v-if="!isConsentant" aria-hidden="true" class="tooltip-favoris-text">
                {{ $t('messageComponent.texteConsentement') }}&nbsp;<a
                  href="javascript:Didomi.reset();Didomi.preferences.show()"
                  target="_self"
                  class="lien-didomi"
                  >{{ $t('messageComponent.texteLienConsentement') }}</a
                >
              </span>
            </button>
          </span>
          <!-- Mis en commentaire parce que on ne la livrera pas dans la version 1  -->
          <!-- <svg-icon class="taille-icone ml-3" icon-name="icone-like" /> -->
          <div v-if="!isProduitDesactive" class="d-none d-xxl-flex ml-3">
            <span @click.capture="gaPreventClick('pleineLargeur')">
              <button class="bouton-icone" @click="modePleineLargeur()">
                <svg-icon class="taille-icone cursor-pointer" icon-name="icone-theatre" />
              </button>
            </span>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-col>
</div>
